import { render, staticRenderFns } from "./ReceivedRequestsFlowSwitcher.vue?vue&type=template&id=479f2f67&"
import script from "./ReceivedRequestsFlowSwitcher.vue?vue&type=script&lang=js&"
export * from "./ReceivedRequestsFlowSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports